var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('div',{staticClass:"logo"}),_c('div',{staticClass:"next",on:{"click":_vm.nextFun}})])
}
var staticRenderFns = []

export { render, staticRenderFns }